import { createAsyncThunk } from '@reduxjs/toolkit'
import { handleError, hasError } from '@repo/shared/api/helpers'

import { AsyncThunkConfig, RejectValue } from '@/store/actions'
import { Feedback } from '@/store/admin.ts'

export const feedback = {
  //
  // ADMIN
  //
  admin: {
    initFeedbacks: createAsyncThunk<{ feedbacks: Feedback[] }, void, AsyncThunkConfig>(
      'ADMIN_INIT_FEEDBACKS',
      async (_, { extra: { altApi }, rejectWithValue, fulfillWithValue, getState }) => {
        const organizationId = getState().user.currentOrganizationId
        if (!organizationId) return rejectWithValue(RejectValue.NoOrganization)

        const feedbacks = await altApi.feedbacks.getAll({ organizationId })
        if (hasError(feedbacks)) return rejectWithValue(handleError(feedbacks))
        return fulfillWithValue({ feedbacks })
      },
    ),
  },
}
